import api from "@/common/js/api"

const $comps = {}

export default {
  namespaced: true,
  state: () => ({
    tradeCenterOptions: {
      ready: false,
      radios: [],
      regions: {},
      isEnableGeneralPurchaseJump: false
    }
  }),
  mutations: {
    setComps(state, { key, $vm }) {
      $comps[key] = $vm
    },
    setIsEnableGeneralPurchaseJump(state, isEnableGeneralPurchaseJump) {
      state.isEnableGeneralPurchaseJump = isEnableGeneralPurchaseJump
    }
  },
  actions: {
    initComps({state}, { key, args }) {
      return $comps[key].init(args)
    },
    initTradeCenterRadios({state}) {
      api.get('/region/list').then(res => {
        if(res.result) {
          let regions = {}
          let radios = res.json.filter(x => x.Name).reduce((pre, cur) => {
            let key = 'x'
            if(/^\d{6}$/.test(cur.Value)) {
              key = cur.Value.slice(0, 2)
            }
            pre[key] = pre[key] || {province: [], city: [], other: []}
            if(/^\d{2}0{4}$/.test(cur.Value)) {
              pre[key].province.push(cur)
            } else if(/^\d{4}0{2}$/.test(cur.Value)) {
              pre[key].city.push(cur)
            } else {
              pre[key].other.push(cur)
            }
            regions[key] = cur
            return pre
          }, {})
          state.tradeCenterOptions.radios = Object.values(radios)
          state.tradeCenterOptions.regions = regions
          state.tradeCenterOptions.ready = true
        }
      })
    },
    getTradeCenterRadios({state}) {
      return new Promise((resolve, reject) => {
        resolve(state.tradeCenterOptions)
      })
    }
  }
}